import { MultiSelectWithAutoTransform } from "./MultiSelectWithAutoTransform";

export class MultiSelectWithInsert extends MultiSelectWithAutoTransform {
    serverDataSource: kendo.data.DataSource;
    doesUpdate: boolean;
    jsonDataSource: boolean;
    isVirtual: boolean;

    constructor(element: Element, options?: kendo.ui.MultiSelectOptions) {
        super(element, options);
        this.doesUpdate = !!options && !!options.dataSource && !!options.dataSource.transport && !!options.dataSource.transport.create;
        this.jsonDataSource = this.doesUpdate && (<string>options.dataSource.transport.create.dataType).indexOf("json") >= 0;
        this.isVirtual = options.virtual !== false;
        if (this.doesUpdate) {
            this.dataSource.bind("requestEnd", this.onRequestEnd);
        } else {
            this.serverDataSource = this.dataSource;
            this.serverDataSource.fetch().then(() => {
                const localDataSource = new kendo.data.DataSource({ data: this.serverDataSource.data().slice(0) });
                localDataSource.read();
                this.setDataSource(localDataSource);
                this.refresh();
            });
        }
    }

    static mapParameterWithInsert(a) {
        const element = a.data("kendoMultiSelectWithInsert").input.val();
        return { text: element };
    }

    private clearInput() {
        this.input.val("");
    }

    addItemClicked() {
        if (!String(this.input.val()).trim()) {
            return;
        }
        if (!this.options.dataValueField) {
            this.dataSource.data().push(this.input.val());
            this.value(this.value().concat([this.input.val()]));
            this.clearInput();
            this.close();
            this.refresh();
        } else {
            const newItem = {};
            newItem[this.options.dataTextField] = this.input.val();
            if (this.doesUpdate) {
                newItem[this.options.dataValueField] = "";
            } else {
                newItem[this.options.dataValueField] = this.options.useTextAsValue
                    ? this.input.val()
                    : Math.random() * 100;
            }
            this.dataSource.add(newItem);
            this.dataSource.sync().then(() => {
                if (!this.doesUpdate) {
                    this.clearInput();
                    this.value(this.value().concat([newItem[this.options.dataValueField]]));
                    this.close();
                    this.refresh();
                }
            });
        }
    }

    onRequestEnd = (args) => {
        if (args.type !== "create") {
            return;
        }
        const newValue = args.response[this.options.dataValueField];
        this.clearInput();
        if (this.isVirtual) {
            this.dataSource.one("sync",
                () => {
                    this.value(this.value().concat([newValue]));
                    this.close();
                });
        } else {
            this.one("dataBound", () => {
                this.value(this.value().concat([newValue]));
                this.close();
            });
            this.dataSource.read();
        }
    }
}

// Create an alias of the prototype (required by kendo.ui.plugin)
MultiSelectWithInsert.fn = MultiSelectWithInsert.prototype;
// Deep clone the widget default options
MultiSelectWithInsert.fn.options = $.extend(true, {}, kendo.ui.MultiSelect.fn.options);
// Specify the name of your Kendo UI widget. Used to create the corresponding jQuery plugin.
MultiSelectWithInsert.fn.options.name = "MultiSelectWithInsert";
// Create a jQuery plugin.
kendo.ui.plugin(MultiSelectWithInsert);

interface JQuery {
    multiSelectWithInsert(options?: kendo.ui.MultiSelectOptions): JQuery;
}
